import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AuthService} from "./auth.service";
import {environment} from "projects/store/src/environments/environment";
import {map} from "rxjs";
import { ResponseHttpSuccess } from 'library';

@Injectable({
  providedIn: 'root'
})
export class CommissionsService {
  url = environment.apiURL;

  constructor(private http: HttpClient,
              private authService: AuthService) { }

  getCommissionsByBrandAndPriceRange(id: string){
    return this.http.get(`${this.url}merchant/commission/user/${id}/payment-promise`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  getAccumulatedCount(id: string){
    return this.http.get(`${this.url}merchant/sales/user/${id}/accumulated-count`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  getAccumulatedBalance(id: string){
    return this.http.get(`${this.url}merchant/commission/user/${id}/balance`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  getRequestPaymentStatus(id: string){
    return this.http.get(`${this.url}merchant/commission/user/${id}/payment-request/status`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  sendRequestPaymentOfCommissions(id: string){
    return this.http.post(`${this.url}merchant/commission/user/${id}/payment-request`, null, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  getSalesOfUser(id: any, month: any, year: any){
    return this.http.get(`${this.url}merchant/sales/user/${id}?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getSalesOfStore(id: any, month: any, year: any){
    return this.http.get(`${this.url}merchant/sales/store/${id}?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getAccumulatedCountDealer(id: string){
    return this.http.get(`${this.url}merchant/sales/distributor/${id}/accumulated-count`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }


  getCommisionsOfUser(id: string, month: number, year: number){
    return this.http.get(`${this.url}merchant/commission/user/${id}/commissions?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getCommisionsOfStore(idStore: string, idUser: string, month: number, year: number){
    return this.http.get(`${this.url}merchant/commission/store/${idStore}/user/${idUser}/commissions?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getCommisionsAcumulatedOfUser(id: string){
    return this.http.get(`${this.url}merchant/commission/user/${id}/balance`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getPaymentsOfUser(id: string, month: number, year: number){
    return this.http.get(`${this.url}merchant/commission/user/${id}/payments?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));

  }
  getCancellationsOfUser(id: string, month: number, year: number){
    return this.http.get(`${this.url}merchant/commission/user/${id}/annulments?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

  getListStoreByDealer(id: any){
    return this.http.get(`${this.url}merchant/distributor/${id}/stores`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getSaleOneStoreByDealer(id: any, month: number, year: number){
    return this.http.get(`${this.url}merchant/sales/store/${id}?month=${month}&year=${year}`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getSalesOfOneStore(id: string){
    return this.http.get(`${this.url}merchant/sales/store/${id}/accumulated-count`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }
  getCommissionsOfOneStore(storeId: string, userId: string){
    return this.http.get(`${this.url}merchant/commission/store/${storeId}/user/${userId}/balance`, this.authService.getHttpOptionsBearer())
      .pipe(map( resp => resp as ResponseHttpSuccess));
  }

}
